import { IQuote, IQuoteItem } from "../../interfaces/IQuote";
import * as cartAPIUtil from "../../util/cart/cartAPIUtil";
import { MArtwork } from "../../models/MArtwork";
import * as catalogueAPIUtil from "../../util/catalogue/catalogueAPIUtil";
import { IArtwork } from "../../interfaces/IArtwork";
export const ADD_TO_CART = "ADD_TO_CART";
export const DECREASE_QUANTITY = "DECREASE_QUANTITY";
export const DELETE_FROM_CART = "DELETE_FROM_CART";
export const DELETE_ALL_FROM_CART = "DELETE_ALL_FROM_CART";
export const ADDDATA_TO_CART = "ADDDATA_TO_CART";
export const RECEIVE_QUOTE_ITEM = "RECEIVE_QUOTE_ITEM";
export const DELETE_PRODUCT_FROM_CART = "DELETE_PRODUCT_FROM_CART";
export const IS_LOADING = "IS_LOADING";
export const DELETE_SIZE_FROM_CART = "DELETE_SIZE_FROM_CART";
export const EDIT_QTY_CART = "EDIT_QTY_CART";
export const RECEIVE_CARTWORKS_LIST_CART = "RECEIVE_CARTWORKS_LIST_CART";
export const DELETE_DECO_CART = "DELETE_DECO_CART";

//add to cart
export const addToCart = (
  item,
  addToast,
  quantityCount,
  selectedProductColor,
  selectedProductSize
) => {
  return dispatch => {
    if (addToast) {
      addToast("Added To Cart", { appearance: "success", autoDismiss: true });
    }
    dispatch({
      type: ADD_TO_CART,
      payload: {
        ...item,
        quantity: quantityCount,
        selectedProductColor: selectedProductColor
          ? selectedProductColor
          : item.selectedProductColor
            ? item.selectedProductColor
            : null,
        selectedProductSize: selectedProductSize
          ? selectedProductSize
          : item.selectedProductSize
            ? item.selectedProductSize
            : null
      }
    });
  };
};
export const addDataToCart = (
  item,
  addToast,
) => {
  return dispatch => {
    if (addToast) {
      addToast("Added To Cart", { appearance: "success", autoDismiss: true });
    }
    dispatch({
      type: ADDDATA_TO_CART,
      payload: item
    });
  };
};
//decrease from cart
export const decreaseQuantity = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Item Decremented From Cart", {
        appearance: "warning",
        autoDismiss: true
      });
    }
    dispatch({ type: DECREASE_QUANTITY, payload: item });
  };
};
//delete from cart
export const deleteFromCart = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Removed From Cart", { appearance: "error", autoDismiss: true });
    }
    dispatch({ type: DELETE_FROM_CART, payload: item });
  };
};
export const deleteSizeFromCart = (item, addToast, rowIndex, sizeindex) => {
  return dispatch => {
    if (addToast) {
      addToast("Removed From Cart", { appearance: "error", autoDismiss: true });
    }
    dispatch({ type: DELETE_SIZE_FROM_CART, payload: item, sizeindex: sizeindex, rowIndex: rowIndex });
  };
};
export const editQtyCart = (item, addToast, rowIndex, sizeindex, qty) => {
  return dispatch => {

    dispatch({ type: EDIT_QTY_CART, payload: item, sizeindex: sizeindex, rowIndex: rowIndex, qty: qty });
  };
};
export const deleteDecoFromCart = (item, addToast, rowIndex, decoIndex) => {
  return dispatch => {

    dispatch({ type: DELETE_DECO_CART, payload: item, rowIndex: rowIndex, decoIndex: decoIndex });
  };
};
export const deleteProductFromCart = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Removed From Cart", { appearance: "error", autoDismiss: true });
    }
    dispatch({ type: DELETE_PRODUCT_FROM_CART, payload: item });
  };
};
//delete all from cart
export const deleteAllFromCart = addToast => {
  return dispatch => {
    if (addToast) {
      addToast("Removed All From Cart", {
        appearance: "error",
        autoDismiss: true
      });
    }
    dispatch({ type: DELETE_ALL_FROM_CART });
  };
};

// get stock of cart item
export const cartItemStock = (item, color, size) => {
  if (item.stock) {
    return item.stock;
  } else {
    return item.variation
      .filter(single => single.color === color)[0]
      .size.filter(single => single.name === size)[0].stock;
  }
};
export const receiveCartOrder = (quote: IQuote) => ({
  type: RECEIVE_QUOTE_ITEM,
  payload: quote
});
export const isLoading = (loading: boolean) => ({
  type: IS_LOADING,
  loading
});
export const fetchOrder = (id) => dispatch => cartAPIUtil.fetchOrder(id)
  .then(res => {
    const quotes = res.data.data;

    dispatch(receiveCartOrder(quotes))
  })
export const receiveArtworks = (artworks: IArtwork[]) => ({
  type: RECEIVE_CARTWORKS_LIST_CART,
  payload: artworks,
});
export const fetchArtworks = (filterData) => dispatch => catalogueAPIUtil.fetchArtworks(filterData)
  .then(res => {
    const artworks: MArtwork[] = res.data.data.map(individualOrder => {
      return new MArtwork(individualOrder);
    });
    const pendingArtworkData = JSON.parse(localStorage.getItem('cpPendingArtwork') || '[]')
    artworks.unshift(...pendingArtworkData)
    dispatch(isLoading(false));
    dispatch(receiveArtworks(artworks))
  }).catch(error => {
    dispatch(isLoading(false));
  });
